import http from '@/api/http'

const REQUEST_URL = '/message/'

export interface SubmitPayload {
  fd: FormData
  httpOptions?: any
}

export default {
  /**
   * チャット一覧を取得
   */
  fetchData(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'get_init',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * submit
   */
  submit({ fd, httpOptions }: SubmitPayload): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, fd, httpOptions)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * resubmit
   */
  resubmit(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'resubmit',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * remove
   */
  remove(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'delete',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 既読通知をサーバに送信
   */
  alreadyRead(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'read',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * メモを編集
   */
  memo(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'memo',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 添付ファイルの購入
   */
  buy(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'buy',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
